import { HttpErrorResponse } from '@angular/common/http';
import { Injectable, OnDestroy } from '@angular/core';
import { ResolveEnd, Router } from '@angular/router';

import { ApplicationInsights } from '@microsoft/applicationinsights-web';
import { filter } from 'rxjs/operators';

import { environment } from 'src/environments/environment';
import { Subscription } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ApplicationInsightsService implements OnDestroy {

  private _appInsights = new ApplicationInsights({
    config: {
      connectionString: environment.appInsightsConnectionString,
      autoTrackPageVisitTime: true
    }
  });
  private routerSub: Subscription;

  constructor(private router: Router) {
    this._appInsights.loadAppInsights();
    this.routerSub = this.router.events.pipe(filter(event => event instanceof ResolveEnd))
      .subscribe((event: ResolveEnd) => {
      const activatedUrl = this.getActivatedUrl(event.urlAfterRedirects);
      if (activatedUrl) {
        this.logPageView(activatedUrl, `${window.location.origin}/#${event.urlAfterRedirects}`);
      }
    });
  }

  ngOnDestroy(): void {
    this.routerSub.unsubscribe();
  }

  get appInsights(): ApplicationInsights {
    return this._appInsights;
  }

  logPageView(name?: string, uri?: string): void {
    this.appInsights.trackPageView({ name, uri });
  }

  logError(exception: Error): void {
    this.appInsights.trackException({ exception });
  }

  logApiError(error: HttpErrorResponse): void {
    this.logError(new Error(`API call failed: ${error.message}`));
  }

  private getActivatedUrl(urlAfterRedirects: string): string {
    const urlTree = this.router.parseUrl(urlAfterRedirects);
    return urlTree.root.children['primary'].segments.map(it => it.path).join('/');
  }

}
